import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import type { Category, SubCategory } from './functions/utils';
import { Headline, Text } from '@/components/typography';
import { SearchFormValuesGCSS } from './hooks/useGcssSearch';
import { CategoryTiles } from '@/components/tiles';
import { LINKS } from '@/constants/links';
import { CategoryDescription } from './CategoryDescription';
import { Link } from '@/components/links';
import type { NoResults as NoResultsType } from './functions/getNoResultsData';
import { Suspense } from 'react';
interface Props {
  fulltext: SearchFormValuesGCSS['fulltext'];
  category?: Category | SubCategory;
  data: NoResultsType;
}
function isSubCategory(category: Category | SubCategory): category is SubCategory {
  return 'paths' in category;
}
export function NoResults(props) {
  const $ = _c(27);
  const {
    t
  } = useTranslation("gcss");
  const {
    data,
    fulltext,
    category
  } = props;
  const isFulltextSearched = Boolean(fulltext);
  let t0;
  if ($[0] !== category || $[1] !== fulltext || $[2] !== isFulltextSearched || $[3] !== t) {
    t0 = isFulltextSearched ? <><Text variant="p3" className="text-gray-600">{t("form.noResults.searchTitle")}</Text><Headline as="h4" className="mt-4">"{fulltext}"</Headline><div className="mt-4">{category && category.description ? <Suspense><CategoryDescription text={category.description} /></Suspense> : <div><Text>{t("form.noResults.emptySearch", {
              term: fulltext
            })}</Text><Headline className="mt-12 mb-4" as="h6">{t("form.noResults.nextSteps.title")}</Headline><ul className="mb-8 list-disc space-y-3 pl-5 marker:text-blue-500 lg:mb-12"><li>{t("form.noResults.nextSteps.items.1")}</li><li>{t("form.noResults.nextSteps.items.2")}</li><li>{t("form.noResults.nextSteps.items.3")}</li></ul></div>}</div></> : category && <><h1 className="mb-8 font-bold lg:text-4xl">{category.name}</h1><Headline as="h6" className="mt-12 mb-4">{t("form.noResults.emptyCategory")}</Headline></>;
    $[0] = category;
    $[1] = fulltext;
    $[2] = isFulltextSearched;
    $[3] = t;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== t) {
    t1 = t("form.noResults.popularTerms");
    $[5] = t;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <Headline as="h6" className="mt-12 mb-4">{t1}</Headline>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== data.terms) {
    t3 = data.terms.map(_temp);
    $[9] = data.terms;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t3) {
    t4 = <section className="flex flex-wrap gap-4 lg:gap-6">{t3}</section>;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t) {
    t5 = t("form.noResults.popularCategories");
    $[13] = t;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t5) {
    t6 = <Headline as="h6" className="mt-12 mb-4">{t5}</Headline>;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== data.categories) {
    t7 = data.categories.map(_temp2);
    $[17] = data.categories;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t7) {
    t8 = <section className="grid grid-cols-2 gap-4 md:grid-cols-3">{t7}</section>;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t0 || $[22] !== t2 || $[23] !== t4 || $[24] !== t6 || $[25] !== t8) {
    t9 = <div>{t0}{t2}{t4}{t6}{t8}</div>;
    $[21] = t0;
    $[22] = t2;
    $[23] = t4;
    $[24] = t6;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
}
function _temp2(category_0) {
  return <CategoryTiles analyticsParam={`emptyResultPopularCategory${category_0.slug}`} testId={`emptyResultPopularCategory${category_0.slug}`} to={isSubCategory(category_0) ? LINKS().gcssSubCategory(category_0.path) : LINKS().gcssCategory(category_0.slug)} key={category_0.slug} title={category_0.name} image={category_0.image ? {
    src: category_0.image,
    alt: category_0.name
  } : undefined} />;
}
function _temp(term) {
  return <Link key={term.name} to={term.link} testId={`emptyResultPopularTerm${term.name}`} analyticsParam={`emptyResultPopularTerm${term.name}`}>{term.name}</Link>;
}